export default "__VITE_ASSET__Q_b_jUvD__"